import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_MEMBER_QRCODE_API } from "@apis/apiPath";

const useMemberTokenApi = () => {
	const Ajax = useAjax();

	const getMemberQrcodeApi = useCallback(
		async memberID => await Ajax.get(GET_MEMBER_QRCODE_API(memberID)),
		// eslint-disable-next-line
		[]
	);

	return {
		getMemberQrcodeApi,
	};
};

export default useMemberTokenApi;
